<template>
    <div v-if="isloaded" class="header-wrapper" id="header-wrapper" :class="{'is_fixed_marBottom': is_fixed}">   
        <div class="header" v-if="!isPhone">
            <div class="header-banner">
                <img src="./../assets/img/banner_v5.png" alt="">
            </div>
            <div class="header-channel-search" :class="{'is_fixed': is_fixed}">
                <div class="header-channel-search-wrapper">
                    <div class="header-channel" id="headerChannel">
                        <div id="channelWrapper" ref="channelWrapper" class="header-channel-wrapper">
                            <div class="channel-item pointer" :class="{'select': pcSelColumn == item.id}" v-for="(item, index) in navColumn" :key="item.id" @click="selColumn(item)">
                                {{item.name}}
                            </div>
                        </div>
                    </div>
                    <div class="moreAndSearch clearfix" id="moreAndSearch">
                        <div class="header-channel-more pointer" v-if="hideIndex > 0">
                            更多
                            <div class="channel-more-wrapper">
                                <div class="channel-item pointer" :class="{'select': pcSelColumn == item.id}" v-for="(item, index) in navColumn.slice(hideIndex - 1, navColumn.length)" :key="item.id" @click="selColumn(item)">
                                    {{item.name}}
                                </div>
                            </div>
                        </div>
                        <div class="header-search-icon" @click="showSearch" id='header-search-icon'>
                            <img class="pointer" src="../assets/img/new_search_icon.png" alt="">
                        </div>
                    </div>
                </div>
                <div id='header-search-wrapper' class="header-search-wrapper" :class="{'header-search-wrapper-show': searchIsShow}">
                    <div class="header-input">
                        <span class="search-icon"></span>
                        <input type="text" placeholder="搜我求证谣言" v-model="searchWord" @keyup.enter="search">
                        <span class="search-btn" @click="search">搜索</span>
                    </div>
                </div>
            </div>
        </div>

        <div :class="{'wap-header':true, 'clearfix':true,noNav:!isShowNav}" v-if="isPhone && !wapHideHeader" >
            <div class="wap-header-channel" v-if="isShowNav">
                <span :class="{'select': wapSelColumn == 'home'}" v-if="indexChannel" @click="selColumn('home')">{{indexChannel.name}}</span>
                <span :class="{'select': wapSelColumn == item.id}" v-for="item in navColumn" :key="item.id" @click="selColumn(item)">{{item.name}}</span>
            </div>
            <div class="arrow" v-if="isShowNav">
                <img src="./../assets/img/arrow.png" alt="" @click="arrowScroll">
            </div>
        </div>
    </div>
</template>
<script>
import { mapState, mapMutations } from 'vuex'
export default {
    name: 'Header',
    data() {
        return {
            searchWord: '',
            pcSelColumn: 136,
            wapSelColumn: 136,
            hideIndex: 0,
            wapHideHeader: false,
            // searchIsShow: false,
            searchInto: false,
            timeOut: null,
            is_fixed: false,
            type: 0, // 类型
            isloaded: false, //是否加载完成
            isShowNav: false,
        }
    },
    async created () {
        if(this.$route.name === 'Search'){
            let isMiniprogram = await this.$Common.Attribute.isMiniprogram()
            this.isShowNav =  isMiniprogram ? false : true;
        }else{
            this.isShowNav = true;
        }
    },
    mounted () {
        
        if (!this.isPhone) {
            this.$nextTick(() => {
                window.addEventListener('scroll', this.watchScroll)
                // window.addEventListener('resize', this.getHideChild)
            })
        }
        document.addEventListener('click', (event) => {
            if (!event.target.closest('#header-search-wrapper') && !event.target.closest('#header-search-icon') && !event.target.closest('#img-to-top')) {
                this.setSearchIsShow(false)
            }
        });
    },
    destroyed () {
        if (!this.isPhone) {
            window.removeEventListener('scroll', this.watchScroll)
            document.removeEventListener('click',) 
        }
    },
    watch: {
        async $route (val, oldVal) {
            this.isloaded = false;
            if(val.path == '/search') {
                // this.searchWord = val.query.keyword || ''
                // if(oldVal.path == '/search' && val.query.keyword != oldVal.query.keyword) {
                //     this.setLoadingShow(true)
                //     this.search()
                // }
            }
            if(this.isPhone) {
                this.isloaded = true;
                if(['News', 'SubjectDetail'].includes(val.name)) {
                    this.wapHideHeader = true;
                    return;
                }
                if(val.params.type && ['5'].includes(val.params.type)) {
                    this.wapHideHeader = true;
                    return;
                }
                // 网友故事隐藏顶部导航条
                if(val.params && val.params.id && this.$Common.Base64.decode(val.params.id) === '208') {
                    this.wapHideHeader = true;
                    return;
                }
                this.wapHideHeader = false;
            } else {
                this.wapHideHeader = false;
            }
            if(val.path != oldVal.path) {
                if(val.params && val.params.type && val.params.id) {
                    this.pcSelColumn = this.$Common.Base64.decode(val.params.id);
                    this.wapSelColumn = this.$Common.Base64.decode(val.params.id);
                } else {
                    this.pcSelColumn = null;
                    this.wapSelColumn = null;
                }
            }
            if(val.path == '/') {
                !this.isPhone && (this.pcSelColumn = 136);
                this.isPhone && (this.wapSelColumn = 136);
            }
            if (val.name == 'SubjectTypeList') {
                this.pcSelColumn = this.$Common.Base64.decode(val.params.id);
                this.wapSelColumn = this.$Common.Base64.decode(val.params.id);
            }
            if(val.params.type || val.query.type) {
                this.type = val.params.type || val.query.type;
            }
            else this.type = 0;

            if(val.name === 'Search'){
                let isMiniprogram = await this.$Common.Attribute.isMiniprogram()
                this.isShowNav =  isMiniprogram ? false : true;
            }else{
                this.isShowNav = true;
            }
            this.isloaded = true;
        },
        indexChannel (val, oldVal) {
            if (val != oldVal && !this.isPhone) {
                this.$nextTick(() => {
                    this.getHideChild()
                })
            }
        },
        navColumn(val, oldVal) {
            if(this.$route.params && (['1', '3'].includes(this.$route.params.type))) {
                val && val.length && val.map(v => {
                    if(v.id == this.$Common.Base64.decode(this.$route.params.id)) {
                        this.pcSelColumn = v.id;
                        this.wapSelColumn = v.id;
                    }
                })
            }
            if (val != oldVal && !this.isPhone) {
                this.$nextTick(() => {
                    this.getHideChild()
                })
            }
        },
        searchWord(newVal, oldVal) {
            if(newVal && newVal.length > 50) {
                this.searchWord = oldVal;
            }
        },
    },
    updated() {
        this.autoSel(); // 监听页面第一次打开头部选中对应栏目
    },
    methods: {
        ...mapMutations(['setShowPop', 'freshSearch', 'setLoadingShow','setSearchIsShow']),
        search() {
            let keyword = this.searchWord
            if(!keyword || !keyword.trim()) {
                return;
            }
            if(this.$route.path == '/search') {
                // 处于搜索页
                this.$router.push({
                    path: '/search',
                    query: {
                        keyword: keyword
                    }
                })
                this.freshSearch(true)
            } else {
                window.open(this.$router.resolve({
                    path: '/search',
                    query: {
                        keyword: keyword
                    }
                })['href'], '_blank')
            }
        },
        toBaoliao() {
            // var r = window.confirm('您即将进入辟谣联盟成员“封面新闻”官网提交辟谣线索，我们将尽快处理。')
            // if(r) {
            //     window.open('http://www.thecover.cn/cloudHelp')
            // }
            let flag = localStorage.getItem('notShowPiyaoPop') || false;
            if(flag) {
                window.open('http://www.thecover.cn/cloudHelp');
                return;
            }
            this.setShowPop(true);
        },
        selColumn(item) {
            // --------------新接口，新逻辑--------------
            this.pcSelColumn = item.id;
            if(!item.channelId) {
                this.isPhone && (this.wapSelColumn = item.id);
                if(item.radioId === 3) return this.$router.push(`/subjectTypeList/${this.$Common.Base64.encode(item.id)}`);
                if(this.isPhone){
                    if(!item.linkUrl){
                        location.href = this.cyLocationHref
                    }else{
                        location.href = item.linkUrl
                    }
                    
                }else{
                    if(item.radioId === 3) return this.$router.push(`/subjectTypeList/${this.$Common.Base64.encode(item.id)}`);
                    if(!item.linkUrl){
                        window.open(this.cyLocationHref, '_blank')
                    }else{
                        window.open(item.linkUrl, '_blank')
                    }
                    
                }
            } else {
                if (item.channelId == 100) {
                    this.$router.push({path: '/', params: {channelId: item.channelId}});
                } else {
                    this.$router.push(`/list/${this.$Common.Base64.encode(item.channelId)}/${this.$Common.Base64.encode(item.id)}`);
                }
            } 
        },
        // select(item) {
        //     // console.log(e)
        //     // if(e.offsetX && e.pageX && e.offsetX - e.pageX > 10) { // 可能需要优化导航栏的选中位置
        //     //     document.getElementsByClassName('wap-header-channel')[0].scrollLeft += e.offsetX
        //     //     console.log(document.getElementsByClassName('select')[0].clientWidth)
        //     // }
        //     // console.log(document.getElementsByClassName('wap-header-channel')[0].scrollLeft)
        //     // this.wapSelColumn = id;
        //     // 执行查询接口
        // },
        arrowScroll() {
            const headerChannel = document.getElementsByClassName('wap-header-channel');
            headerChannel && headerChannel[0] && (headerChannel[0].scrollLeft += headerChannel[0].clientWidth);
        },
        autoSel() {
            if(this.isPhone && !this.wapHideHeader && this.$route.params) {
                if(this.$route.params.type && ['1', '3'].includes(this.$route.params.type)) {
                    this.$route.params.id && this.navColumn && this.navColumn.length && this.navColumn.map(v => {
                        if(v.id == this.$Common.Base64.decode(this.$route.params.id)) {
                            this.isPhone && (this.wapSelColumn = v.id);
                            !this.isPhone && (this.pcSelColumn = v.id);
                        }
                    })
                    let dom = document.getElementsByClassName('select')[0];
                    if(dom) {
                        if(dom.offsetLeft && dom.parentNode.clientWidth && dom.offsetLeft > dom.parentNode.clientWidth) {
                            dom.parentNode.scrollLeft += dom.offsetLeft
                        }
                    }
                }
            }
        },
        getHideChild() {
            let channelWrapper = document.getElementById('channelWrapper')
            let headerChannel = document.getElementById('headerChannel')
            let moreAndSearch = document.getElementById('moreAndSearch')
            if (!channelWrapper || !headerChannel) return;
            let outWidth = headerChannel.clientWidth
            let rootFontSize = Number(document.querySelector('html').style.fontSize.split('px')[0])
            let childs = channelWrapper.children
            let childArr = []
            let computeWidth = 0
            childs && (childArr = Array.from(childs))
            if (childArr.length) {
                for (let i = 0; i < childArr.length; i++) {
                    let current = childArr[i]
                    // computeWidth += current.clientWidth
                    computeWidth += Math.floor(current.getBoundingClientRect().width)
                    // console.log(outWidth,current.clientWidth,current.getBoundingClientRect().width)
                    if (computeWidth - outWidth > 0) {
                        this.hideIndex = i
                        computeWidth = computeWidth - current.clientWidth // 计算当前区域宽度，让更多按钮贴近
                        break;
                    }
                }
            }
            if (this.hideIndex > 0) {
                // moreAndSearch.style.left = ((computeWidth / rootFontSize) - 55.375)  + 'rem'
            }
            // if (!this.indexChannel && this.hideIndex > 0) {
            //     this.hideIndex -= 1
            // }
        },
        showSearch() {
            console.log(this.searchIsShow)
            this.setSearchIsShow(true)
        },
        hideSearch(e) {
            if(e.relatedTarget === null) {}
            else {
                this.timeOut = setTimeout(() => {
                    if (!this.searchInto) {
                        this.searchIsShow = false
                    }
                }, 300);
            }
        },
        intoSearch() {
            this.searchInto = true
        },
        leaveSearch(e) {
            if(e.relatedTarget === null) {}
            else {
                this.searchInto = false
                this.searchIsShow = false
            }
        },
        watchScroll() {
            let scrollTop = document.body.scrollTop || document.documentElement.scrollTop
            let rootFontSize = Number(document.querySelector('html').style.fontSize.split('px')[0])
            let headerSearchHeight = 11.0172 * rootFontSize
            if (scrollTop >= headerSearchHeight) {
                this.is_fixed = true
            } else {
                this.is_fixed = false
            }
        }
    },
    computed: {
        ...mapState(['indexChannel', 'columnList','searchIsShow']),
        isPhone() {
            return this.$Common.Attribute.isMb()
        },
        navColumn() {
            return this.columnList
        },
        holder() {
            if(this.navColumn && this.navColumn.length) {
                if(this.navColumn.length == 1) {
                    return 3
                } else if(this.navColumn.length == 2) {
                    return 2
                } else if(this.navColumn.length == 3) {
                    return 1
                }
                return 0
            }
            return 0
        },
        isProduction() {
            return location.host == 'scpiyao.org.cn' || location.host == 'www.scpiyao.org.cn'
        },
        cyLocationHref() {
            if(this.isProduction) return 'https://www.scpiyao.org.cn/cy';
            else return 'https://piyao-web.fm-dev.thecover.cn/cy';
        },
    }
}
</script>
<style lang="less" scoped>
.header-wrapper {
    font-size: 0;
    .header {
        width: 100%;
        // .header-banner {
            // height: 12.875rem;
        // }
        .header-banner-7 {
            height: 12rem;
            margin-bottom: 2rem;
            img {
                height: auto;
            }
        }
        .header-channel-search {
            width: 100%;
            height: 4.1875rem;
            background: #182476;
            box-shadow: 0px 3px 7px 0px rgba(0,67,193,0.11);
            position: relative;
            .header-channel-search-wrapper {
                width: 64rem;
                height: 100%;
                margin: 0 auto;
                color: #FFFFFF;
                font-size: 1.25rem;
                .header-channel {
                    float: left;
                    // max-width: 55.375rem;
                    width: 55.375rem;
                    overflow: hidden;
                    height: 100%;
                    .header-channel-wrapper {
                        display: flex;
                        flex-wrap: wrap;
                        .channel-item {
                            flex-grow: 1;
                            flex-shrink: 0;
                            text-align: center;
                            display: inline-block;
                            height: 4.1875rem;
                            position: relative;
                            padding: 0 1.5625rem;
                            line-height: 4.1875rem;
                            &:first-of-type {
                                padding: 0 1.5625rem 0 0;
                            }
                            &::after {
                                content: '';
                                display: block;
                                width: 1px;
                                height: 1.4375rem;
                                background: #70C4FF;
                                position: absolute;
                                right: 0;
                                top: 50%;
                                transform: translateY(-50%);
                            }
                        }
                        .select {
                            color: #2470FF;
                        }
                    }
                }
                .moreAndSearch {
                    display: inline-block;
                    position: relative;
                    .header-channel-more {
                        float: left;
                        height: 100%;
                        line-height: 4.1875rem;
                        padding: 0 1.5625rem;
                        position: relative;
                        &:hover {
                            .channel-more-wrapper {
                                display: block;
                            }
                            &::before {
                                display: block;
                                content: '';
                                width: 0;
                                height: 0;
                                border-right: .75rem solid transparent;
                                border-left: .75rem solid transparent;
                                border-bottom: .75rem solid #ffffff;
                                position: absolute;
                                bottom: 0;
                                left: 50%;
                                transform: translateX(-50%);
                            }
                        }
                        &::after {
                            content: '';
                            display: block;
                            width: 1px;
                            height: 1.4375rem;
                            background: #70C4FF;
                            position: absolute;
                            right: 0;
                            top: 50%;
                            transform: translateY(-50%);
                        }
                        .channel-more-wrapper {
                            padding: .625rem 0;
                            background: #FFFFFF;
                            box-shadow: 0px 4px .625rem 1px rgba(0, 0, 0, 0.1);
                            position: absolute;
                            top: 4.1875rem;
                            left: 50%;
                            transform: translateX(-50%);
                            box-sizing: border-box;
                            z-index: 999;
                            display: none;
                            max-height: 30rem;
                            overflow-y: auto;
                            .channel-item {
                                // display: inline-block;
                                height: 2.875rem;
                                position: relative;
                                padding: 0 1.5625rem;
                                line-height: 2.875rem;
                                white-space: nowrap;
                                max-width: 17.8125rem;
                                overflow: hidden;
                                text-overflow: ellipsis;
                                color: #333333;
                                &:hover {
                                    background: #EEF8FF;
                                }
                            }
                            .select {
                                color: #2470FF;
                            }
                        }
                    }
                    .header-search-icon {
                        float: left;
                        height: 100%;
                        padding: 0 0 0 1.5625rem;
                        line-height: 4.1875rem;
                        img {
                            width: 1.1875rem;
                            height: 1.1875rem;
                        }
                    }
                }
            }
            .header-search-wrapper {
                width: 100%;            
                height: 0;
                background: #FFFFFF;
                box-shadow: 0px 4px .625rem 1px rgba(0, 0, 0, 0.08);
                position: absolute;
                transition: all .3s;
                opacity: 0;
                z-index: 888;
                .header-input {
                    width: 22.6875rem;
                    height: 2.375rem;
                    border-radius: 1.1875rem;
                    position: relative;
                    border: 1px solid #E0E1E5;
                    margin: 0 auto;
                    margin-top: .9375rem;
                    display: none;
                    input {
                        width: 18.75rem;
                        height: 100%;
                        text-indent: 2.6875rem;
                        color: #626262;
                        border: none;
                        outline: 0;
                        border-radius: 1.1875rem;
                        font-size: .875rem;
                    }
                    .search-icon {
                        position: absolute;
                        background: url('./../assets/img/search_icon_gray.png') no-repeat center;
                        background-size: cover;
                        display: inline-block;
                        width: 1.1875rem;
                        height: 1.1875rem;
                        left: .875rem;
                        top: 50%;
                        transform: translateY(-50%);
                    }
                    .search-btn {
                        color: #2470FF;
                        font-size: .875rem;
                        line-height: 2.375rem;
                        position: absolute;
                        right: .875rem;
                        top: 50%;
                        transform: translateY(-50%);
                        cursor: pointer;
                    }
                }
            }
            .header-search-wrapper-show {
                height: 4.1875rem;
                opacity: 1;
                .header-input {
                    display: block;
                }
            }
        }
        .is_fixed {
            position: fixed;
            top: 0;
            left: 0;
            z-index: 9999;
        }
    }

    .wap-header {
        width: 100%;
        min-height: 13.067vw;
        background: #0076FF;
        overflow: hidden;
        .wap-header-channel {
            width: 90%;
            height: 100%;
            overflow-x: scroll;
            overflow-y: hidden;
            white-space: nowrap;
            float: left;
            span {
                font-size: 4vw;
                line-height: 13.067vw;
                color: #fff;
                margin-left: 3.067vw;
            }
            .select {
                font-size: 4.533vw;
                position: relative;
                &::after {
                    content: '';
                    display: block;
                    position: absolute;
                    width: 80%;
                    height: 2px;
                    bottom: -2.233vw;
                    left: 50%;
                    transform: translate(-50%, -50%);
                    background: #fff;
                    border-radius: 2px;
                }
            }
        }
        .arrow {
            width: 10%;
            height: 100%;
            float: left;
            text-align: center;
            line-height: 13.067vw;
            img {
                width: 50%;
                height: auto;
                vertical-align: middle;
            }
        }
    }
    .noNav {
        background: #fff;
    }
}
.is_fixed_marBottom {
    margin-bottom: 5.1875rem;
}
</style>